import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL 
  || (process.env.NODE_ENV === 'production' 
    ? window.location.origin 
    : 'http://localhost:5001');

const statusListeners = new Set();

function notifyStatusChange(status) {
  statusListeners.forEach((cb) => cb(status));
}

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
    this.connectionStatus = 'disconnected';
  }

  connect() {
    if (this.socket) return;

    this.connectionStatus = 'connecting';
    notifyStatusChange(this.connectionStatus);

    this.socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      autoConnect: true,
    });

    this.socket.on('connect', () => {
      this.connectionStatus = 'connected';
      notifyStatusChange(this.connectionStatus);
    });

    this.socket.on('disconnect', () => {
      this.connectionStatus = this.socket?.connected ? 'connected' : 'disconnected';
      notifyStatusChange(this.connectionStatus);
    });

    this.socket.on('error', () => {
      this.connectionStatus = 'disconnected';
      notifyStatusChange(this.connectionStatus);
    });
  }

  subscribeToStatus(callback) {
    statusListeners.add(callback);
    if (this.socket) {
      callback(this.socket.connected ? 'connected' : 'disconnected');
    } else {
      callback('disconnected');
    }
    return () => statusListeners.delete(callback);
  }

  joinScan(scanId) {
    if (!this.socket) this.connect();
    const access_token = localStorage.getItem('access_token');
    this.socket.emit('join_scan', {
      scan_id: scanId,
      access_token,
    });
  }

  on(event, callback) {
    if (!this.socket) this.connect();
    this.socket.on(event, callback);
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

const socketService = new SocketService();
export default socketService;



